import { makeAutoObservable, runInAction } from "mobx";
import { IMerchantOnboarding } from "../onboarding-types";
import OnboardingDataStore, {
    IGetMerchantOnboardingModel,
    IOnboardingScreenStore
} from "./onboarding-data-store";
import { ONBOARDING_STEPS } from "../constants";
import { OnboardingNavigationStore } from "./onboarding-navigation-store";

export class WelcomeScreenStore implements IOnboardingScreenStore {
    private _getModel: IGetMerchantOnboardingModel;
    private _onboardingDataStore: OnboardingDataStore;
    private readonly _stepName: ONBOARDING_STEPS = ONBOARDING_STEPS.NEW_USER_WELCOME;
    private _isLoading: boolean = false;
    
    constructor(onboardingDataStore: OnboardingDataStore, private _navigationStore: OnboardingNavigationStore) {
        this._onboardingDataStore = onboardingDataStore;
        this._getModel = this._onboardingDataStore.getModel;
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public getMixPanelData(): Record<string, any> {
        return {};
    }

    public isComplete(): boolean {
        return !!this._onboardingDataStore.getModel();
    }

    public getUpdatedModel(): IMerchantOnboarding {
        return {...this._getModel() } as IMerchantOnboarding;
    }

    public hasChanges(): boolean {
        return true;
    }

    public discardChanges(): void {}

    public async nextStep(): Promise<void> {
        this._isLoading = true;
        await this._onboardingDataStore.save(this._stepName);
        runInAction(() => {
            this._navigationStore.nextStep();
            this._isLoading = false;
        });
    }

}

export default WelcomeScreenStore;